import FormControl from "@mui/material/FormControl";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4
};

const AddAppModal = (props) => {
    const {openAdd,setOpenAdd,handleFileChange,handleAddChange,handleAddSubmit,appName,appDescription,appHomeUrl,loading} = props;

    return (
        <Modal open={openAdd} onClose={() => setOpenAdd(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h4" component="h2">
                    Add App Data
                </Typography>
                <br></br>
                <Typography id="modal-modal-title" variant="h6" component="h6">
                    <FormControl fullWidth>
                        <TextField sx={{ mb: 1 }} id="app_name" label="Name" value={appName} onChange={handleAddChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="app_description" label="Description" value={appDescription} onChange={handleAddChange} />
                        <br></br>
                        Upload Logo:
                        <Input id="app_image_url" type="file" onChange={handleFileChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="app_home_url" label="Home Url" value={appHomeUrl} onChange={handleAddChange} />
                        <br></br>
                    </FormControl>
                </Typography>

                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    {loading ? <CircularProgress sx={{ color: "blue", marginLeft: "5%" }} /> :
                    <Button type="submit" variant="contained" color="primary" onClick={()=> handleAddSubmit(appName,appDescription,appHomeUrl)} disabled={!(appName && appHomeUrl)}>
                        Submit
                    </Button>}
                </Typography>
            </Box>
        </Modal>
    )
}

export  default AddAppModal;

